// Author lidongxu
// Date 2024-06-13 10:47:30

import * as model from "@/model/em/admin/EmDictDataModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmDictData(), newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_ADMIN_URL,
        selectRowsToItems: function (row) {
            return {value: row.id, text: row.dictLabel}
        },
    })
    .buildStore()
